/* Dear Me pop-up (sections/dearme-popup.liquid). Instellingen staan als data-attributen op .dmp-root. */
(function () {
  if (window.dmPopupGeladen) return;
  window.dmPopupGeladen = true;

  // dm-popup.css laadt zonder te blokkeren (media print, daarna all): pas openen als die er is
  function cssKlaar(klaar) {
    var link = document.querySelector('link[data-dmp-css]');
    if (!link) { klaar(); return; }
    function aan() { link.media = 'all'; klaar(); }
    // Firefox maakt link.sheet al aan tijdens het laden: pas klaar als de regels leesbaar zijn
    function geladen() { try { return !!(link.sheet && link.sheet.cssRules && link.sheet.cssRules.length); } catch (e) { return false; } }
    if (link.media !== 'print' || geladen()) { aan(); return; }
    link.addEventListener('load', aan);
  }

  function dmpInit(root) {
    if (!root || root.dataset.dmpKlaar === '1') return;
    root.dataset.dmpKlaar = '1';

    var uid = root.id.replace('dearme-popup-', '');
    var paneel = root.querySelector('.dmp-paneel');
    var stappen = root.querySelectorAll('[data-dmp-stap]');
    var form = root.querySelector('[data-dmp-form]');
    var veld = root.querySelector('.dmp-veld');
    var foutEl = root.querySelector('[data-dmp-fout]');
    var knop = root.querySelector('[data-dmp-verstuur]');
    var knopTekst = root.querySelector('[data-dmp-knop-tekst]');
    var spinner = root.querySelector('.dmp-spinner');
    var sleutel = 'dearme_popup_' + uid;
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var keuze = '';
    var timer = null;

    function magTonen() {
      if (designMode) return true;
      var doel = root.dataset.toonOp || 'alles';
      var pad = window.location.pathname;
      if (doel === 'home' && pad !== '/' && pad.indexOf('/?') !== 0) return false;
      if (doel === 'product' && pad.indexOf('/products/') === -1) return false;
      if (pad.indexOf('/cart') === 0 || pad.indexOf('/checkouts') === 0) return false;
      try {
        var tot = window.localStorage.getItem(sleutel);
        if (tot && Date.now() < parseInt(tot, 10)) return false;
      } catch (e) {}
      return true;
    }

    function onthoud() {
      var dagen = parseInt(root.dataset.frequentie, 10);
      if (!dagen || designMode) return;
      try {
        window.localStorage.setItem(sleutel, String(Date.now() + dagen * 86400000));
      } catch (e) {}
    }

    function toonStap(n) {
      for (var i = 0; i < stappen.length; i++) {
        stappen[i].hidden = stappen[i].getAttribute('data-dmp-stap') !== String(n);
      }
    }

    function toon() {
      if (!root.hidden) return;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      onthoud();
      var eerste = root.querySelector('.dmp-keuze, .dmp-veld');
      if (eerste && !designMode) { setTimeout(function () { eerste.focus({ preventScroll: true }); }, 320);}
    }

    function open() {
      cssKlaar(toon);
    }

    function sluit() {
      root.classList.remove('is-open');
      onthoud();
      setTimeout(function () { root.hidden = true; }, 260);
    }

    root.querySelectorAll('[data-dmp-sluit], [data-dmp-sluit-buiten]').forEach(function (el) {
      el.addEventListener('click', sluit);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) sluit();
    });
    if (paneel) paneel.addEventListener('click', function (e) { e.stopPropagation(); });

    // Alleen de echte antwoorden (class dmp-keuze) gaan door naar stap 2 met het e-mailveld. Sla over is geen antwoord:
    // die sluit de pop-up en onthoudt dat, net als het kruisje (ook als oudere markup er nog data-dmp-keuze op heeft).
    root.querySelectorAll('[data-dmp-keuze]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!b.classList.contains('dmp-keuze')) { sluit(); return; }
        keuze = b.getAttribute('data-dmp-keuze') || '';
        b.classList.add('is-gekozen');
        setTimeout(function () { toonStap(2); if (veld) veld.focus({ preventScroll: true }); }, 220);
      });
    });

    function toonFout(tekst) {
      if (!foutEl) return;
      foutEl.textContent = tekst;
      foutEl.hidden = false;
      if (veld) veld.classList.add('is-fout');
    }

    function bezig(aan) {
      if (knop) knop.disabled = aan;
      if (spinner) spinner.hidden = !aan;
      if (knopTekst) knopTekst.style.opacity = aan ? '0.7' : '';
    }

    function companyId() {
      var opgegeven = (root.dataset.company || '').trim();
      if (opgegeven) return opgegeven;
      var s = document.querySelector('script[src*="klaviyo.js"]');
      if (s) {
        var m = s.src.match(/company_id=([A-Za-z0-9]+)/) || s.src.match(/onsite\/js\/([A-Za-z0-9]+)\//);
        if (m) return m[1];
      }
      return '';
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (foutEl) foutEl.hidden = true;
        if (veld) veld.classList.remove('is-fout');

        var mail = (veld && veld.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) {
          toonFout(root.dataset.foutEmail || '');
          return;
        }

        var company = companyId();
        var lijst = (root.dataset.lijst || '').trim();
        if (!company) {
          toonFout(root.dataset.foutAlgemeen || '');
          return;
        }

        bezig(true);

        var props = {};
        var propNaam = (root.dataset.eigenschap || '').trim();
        if (propNaam && keuze) props[propNaam] = keuze;
        props['Kortingscode'] = root.dataset.code || '';

        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: root.dataset.bron || 'Website pop-up',
              profile: { data: { type: 'profile', attributes: { email: mail, properties: props } } }
            }
          }
        };
        if (lijst) {
          body.data.relationships = { list: { data: { type: 'list', id: lijst } } };
        }

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'revision': '2026-07-15', 'content-type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          bezig(false);
          if (r.status >= 200 && r.status < 300) {
            if (window.klaviyo && window.klaviyo.push) {
              try { window.klaviyo.push(['identify', { '$email': mail }]); } catch (err) {}
            }
            toonStap(3);
          } else {
            toonFout(root.dataset.foutAlgemeen || '');
          }
        }).catch(function () {
          bezig(false);
          toonFout(root.dataset.foutAlgemeen || '');
        });
      });
    }

    var kopieer = root.querySelector('[data-dmp-kopieer]');
    if (kopieer) {
      kopieer.addEventListener('click', function () {
        var code = root.dataset.code || '';
        var hint = root.querySelector('[data-dmp-kopieer-hint]');
        var origineel = hint ? hint.textContent : '';
        function gelukt() {
          if (!hint) return;
          hint.textContent = root.dataset.gekopieerd || '';
          setTimeout(function () { hint.textContent = origineel; }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(gelukt).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); gelukt(); } catch (err) {}
          document.body.removeChild(t);
        }
      });
    }

    if (root.dataset.slaKeuzeOver === 'true') toonStap(2);

    if (!magTonen()) return;

    if (designMode) { open(); return; }

    // Pas openen als de bezoeker iets gedaan heeft (scrollen, tikken, klikken of een toets). De vertraging loopt vanaf
    // het laden; is er dan nog niets gebeurd, dan wacht de pop-up op de eerste scroll of tik en komt hij kort daarna,
    // zodat die tik gewoon doorgaat. Wie niets doet, krijgt hem niet te zien.
    var vertraging = parseFloat(root.dataset.vertraging || '5') * 1000;
    var gedaan = false;
    var tijdOm = false;
    var geopend = false;
    var inMand = false;
    var wachter = null;
    var PRIKKELS = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];

    // Niet over een ander venster heen (1 nov: hij ging na 30 s open over de winkelwagen). Telt: een lade van het
    // thema, een open dialog, het menu, een aria-modal-venster en de cookiemelding (de eigen kaart of die van
    // Shopify), alleen als ze te zien zijn.
    var VENSTERS = 'theme-drawer[open], dialog[open], header-drawer details[open], [aria-modal="true"], [data-dmcc-kaart], #shopify-pc__banner, #shopify-pc__prefs';
    function anderVenster() {
      var lijst = document.querySelectorAll(VENSTERS);
      for (var i = 0; i < lijst.length; i++) {
        if (root.contains(lijst[i])) continue;
        // theme-drawer heeft display: contents, dus geen eigen vak
        if (lijst[i].tagName === 'THEME-DRAWER' || lijst[i].getClientRects().length) return true;
      }
      return false;
    }

    function openEens() {
      if (geopend || inMand) return;
      if (anderVenster()) { wachtTotDicht(); return; }
      geopend = true;
      open();
    }

    // Staat er iets open: elke halve seconde kijken en openen als alles twee keer achter elkaar dicht is
    function wachtTotDicht() {
      if (wachter) return;
      var vrij = 0;
      wachter = setInterval(function () {
        vrij = anderVenster() ? 0 : vrij + 1;
        if (inMand || geopend || vrij >= 2) {
          clearInterval(wachter);
          wachter = null;
          openEens();
        }
      }, 500);
    }

    // Iets aan de mand toegevoegd in deze paginaweergave: dan komt hij hier niet meer. Het eerste sein telt: een
    // /cart/add-formulier (de eigen koopknoppen), het thema-event of een verzoek naar /cart/add (een app). Op window
    // met capture, want dearme-cart.js stopt de submit op document.
    var MAND = /\/cart\/add(\.js)?([?#]|$)/;
    function toegevoegd() {
      inMand = true;
      clearTimeout(timer);
    }
    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.getAttribute && MAND.test(f.getAttribute('action') || '')) toegevoegd();
    }, true);
    window.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.action === 'add') toegevoegd();
    }, true);
    try {
      new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (x) {
          if (x.name.indexOf(location.origin + '/') === 0 && MAND.test(x.name)) toegevoegd();
        });
      }).observe({ type: 'resource', buffered: true });
    } catch (e) {}

    function prikkel(e) {
      if (gedaan) return;
      // Alleen de pagina zelf telt als scroll, niet een carrousel die vanzelf doorschuift
      if (e && e.type === 'scroll') {
        var t = e.target;
        var pagina = t === document || t === document.documentElement || t === document.body || t === document.scrollingElement || (t && t.classList && t.classList.contains('page-wrapper'));
        if (!pagina) return;
      }
      gedaan = true;
      PRIKKELS.forEach(function (t) { window.removeEventListener(t, prikkel, true); });
      if (tijdOm) setTimeout(openEens, 600);
    }
    PRIKKELS.forEach(function (t) { window.addEventListener(t, prikkel, { capture: true, passive: true }); });
    timer = setTimeout(function () {
      tijdOm = true;
      if (gedaan) openEens();
    }, vertraging);

    if (root.dataset.exitIntent === 'true') {
      document.addEventListener('mouseout', function bij(e) {
        if (e.clientY <= 0 && !e.relatedTarget) {
          clearTimeout(timer);
          document.removeEventListener('mouseout', bij);
          openEens();
        }
      });
    }
  }

  function alles() {
    document.querySelectorAll('.dmp-root[id^="dearme-popup-"]').forEach(dmpInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles);
  } else {
    alles();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.detail && document.getElementById('dearme-popup-' + e.detail.sectionId);
    if (r) {
      r.dataset.dmpKlaar = '';
      dmpInit(r);
    }
  });
})();
